import { TResponse } from '../../../common/types';
import { superAppApi } from '../../../core';

interface IMall {
  id: string;
  type: 'Mall';
  attributes: {
    name: string;
    cover: string;
  };
}

const mallApi = superAppApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    getMalls: build.query<IMall[], void>({
      query: () => ({
        url: '/malls',
      }),
      transformResponse: (response: TResponse<IMall[]>) => response.data,
    }),
  }),
});

export const { useGetMallsQuery } = mallApi;
